<app-search-result   [data]="{allList:true,filter:true}"></app-search-result>
